module.exports = __webpack_public_path__ + "static/media/likeColor.5b811d43.png";